<template>
    <div class="text-input">
        <div @click="closeList()" v-if="open" class="dropdown-background"></div>
        <label><b>{{label}}</b></label>
        <div class="input-group">

            <!-- <select class="form-control"
                    :placeholder="placeholder"
                    v-model="displayValue"
                    @change="updateColleague"
                    :disabled="disabled"
                    :aria-label="{label}">
                <option :value="null" >None</option>
                <option v-for="(pm, index) in colleagues"
                        :key="pm.Code"
                        :value="pm.Code">{{ pm.FirstName }} {{ pm.LastName }} - {{pm.Email}}</option>
            </select>
            <i class="fa fa-chevron-down"></i> -->
            <input class="form-control pr-4"
                    :placeholder="placeholder"
                    v-model="displayValue"
                    @focus="openList()"
                    ref="colleagueSelect"
                    :disabled="disabled"
                    :aria-label="{label}"/>
                 <i @click="focusAutoComplete()" class="fa fa-angle-down icon-dropdown"  aria-hidden="true"></i>
            
            <div v-if="open" class="rep-list-card card ">
                <ul class="p-0 m-0">
                    <div class="pointer rep-list" v-for="pm in colleagueOptions" :key="pm.Code" @click="updateValue(pm)">{{ pm.FirstName }} {{ pm.LastName }} - {{pm.Email}}</div>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ColleagueSelect",
        props: {
            colleagues: {
                type: Array,
            },
            label: {
                type: String,
            },
            placeholder: {
                type: String,
            },
            value: {
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },

        data(){
            return {
                displayValue: "",
                open: false
            }
        },
        methods: {
            focusAutoComplete(){
                this.$refs.colleagueSelect.focus()
            },
            // updateColleague($event){
            //     let value = $event.target.value;
            //     let colleagueCode = value ? Number(value) : null;
            //     this.$emit('input',colleagueCode);
            // },
            openList(){
                this.displayValue = "";
                this.open = true;
            },
            closeList(){
                this.displayValue = this.getColleagueDescription(this.value)
                this.open = false;
            },
            updateValue(Colleague){
                console.log('colleague',Colleague)
                this.displayValue = Colleague.FirstName + " " + Colleague.LastName;
                let colleagueCode = Colleague.Code;
                console.log('colleague',Colleague.Code, colleagueCode)
                this.$emit('input',colleagueCode);
                this.closeList()
            },
            getColleagueDescription(code){
                if(code === null) return "";
                let index = this.colleagues.map(rep => rep.Code).indexOf(code)
                if(index < 0) return ""
                return this.colleagues[index].FirstName + " " + this.colleagues[index].LastName + " - " +  this.colleagues[index].Email 
            }
            
        },
        watch: {
            value: function(){
                this.displayValue = this.getColleagueDescription(this.value);
            },
            colleagues: function(){
                this.displayValue = this.getColleagueDescription(this.value);
            }
        },
        computed: {
            colleagueOptions(){
                let repOptions = this.colleagues.filter(rep => {
                    let discription = rep.FirstName + " " + rep.LastName + " - " + rep.Email;
                    discription = discription.toLowerCase()
                    return discription.includes(this.displayValue.toLowerCase())
                })
                return repOptions.sort(function(a, b) {
                    var textA = a.FirstName.toUpperCase();
                    var textB = b.FirstName.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
            }
            
        },
        created(){
            this.displayValue = this.getColleagueDescription(this.value);
        }
    }
</script>

<style scoped lang="scss">
    .icon-dropdown{
        position: absolute;
        right: 10px;
        top: 10px;
    }
    .rep-list-card{
        z-index: 15;
        margin-top: 40px;
        position: absolute;
        max-height: 300px;
        overflow: scroll;
        
    }
    .rep-list{
        border-bottom: solid .5px grey;
        z-index: 20;
        padding: 5px;
        &:hover {
            background-color: $ss-blue-light;
            color: black;
        }
    }
    .dropdown-background{
        position: fixed;
        min-width: 100%;
        min-height: 100%;
        z-index: 10;
        left: 0; 
        top: 0;
        }
    .form-group{
        margin-bottom: 0px;
        select {
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            /* no standardized syntax available, no ie-friendly solution available */
        }
        select + i.fa {
            float: right;
            margin-top: -26px;
            margin-right: 5px;
            /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
            pointer-events: none;
            background: inherit;
            /* everything after this is just to cover up the original arrow */
            /* (for browsers that don't support the syntax used above) */
            padding-right: 5px;
        }
    }
</style>
